import axios from "axios";
import { baseUrlApiOtodis, xApiKeyOtodis } from "../../config/api/apiConfig";

class OrderService {
  private axios = axios.create({
    // baseURL: "http://localhost:3000",
    baseURL: baseUrlApiOtodis,
  });
  private axiosFile = axios.create({
    baseURL: baseUrlApiOtodis,
    responseType: "blob",
  });

  public setToken(token: string) {
    this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  public async getOrder(params?: any) {
    const queries = {
      ...(params?.dealerCode && {
        dealer_code: params.dealerCode,
      }),
      ...(params?.orderCode && {
        order_code: params.orderCode,
      }),
      ...(params?.dataType && {
        date_type: params.dataType,
      }),
      ...(params?.dateStart && {
        date_start: params.dateStart,
      }),
      ...(params?.dateEnd && {
        date_end: params.dateEnd,
      }),
      ...(params?.statusOrder && {
        status: params.statusOrder,
      }),
      ...(params?.vehicleEngineNumber && {
        vehicle_engine_number: params.vehicleEngineNumber,
      }),
      ...(params?.transferTitleStatus && {
        transfer_title_status: params.transferTitleStatus,
      }),
      ...(params?.orderVatCounter && {
        order_vat_counter: params.orderVatCounter,
      }),
    };
    try {
      return await this.axios.get<any>("/order", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.message);
    }
  }

  public async insertOrder(inputData?: any) {
    try {
      return await this.axios.post<any>("/order", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e?.response?.data?.message);
    }
  }

  public async insertMultiOrder(inputData?: any) {
    try {
      return await this.axios.post<any>("/order/multi", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e?.response?.data?.message);
    }
  }

  public async getOrderByStatus(params?: any) {
    const queries = {
      ...(params?.dealerCode && {
        dealer_code: params.dealerCode,
      }),
      ...(params?.orderCode && {
        order_code: params.orderCode,
      }),
      ...(params?.dataType && {
        date_type: params.dataType,
      }),
      ...(params?.dateStart && {
        date_start: params.dateStart,
      }),
      ...(params?.dateEnd && {
        date_end: params.dateEnd,
      }),
      ...(params?.statusOrder && {
        status: params.statusOrder,
      }),
      ...(params?.vehicleEngineNumber && {
        vehicle_engine_number: params.vehicleEngineNumber,
      }),
      ...(params?.transferTitleStatus && {
        transfer_title_status: params.transferTitleStatus,
      }),
      ...(params?.orderVatCounter && {
        order_vat_counter: params.orderVatCounter,
      }),
      ...(params?.handoverStatus && {
        handover_status: params.handoverStatus,
      }),
    };
    try {
      return await this.axios.get<any>("/order/status", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.message);
    }
  }

  public async generateCsv(inputData?: any) {
    try {
      return await this.axiosFile.put<any>("/order/vat-out/gen-csv", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (error: any) {
      const blob = new Blob([error?.response?.data]);
      const aa = await blob.text();
      const x = JSON.parse(aa);
      throw new Error(x?.message);
    }
  }

  public async insertVatNumber(inputData?: any) {
    try {
      return await this.axiosFile.put<any>("/order/vat-out/insert-vat-number", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.message);
    }
  }

  public async updateCustomerData(inputData?: any) {
    try {
      return await this.axios.put<any>("/order/update/customer-data", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (error: any) {
      throw new Error(error.response.data.message);
    }
  }

  public async deliveryManual(inputData?: any) {
    try {
      return await this.axios.post<any>("/order/delivery/manual", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e?.response?.data?.message);
    }
  }

  public async deliveryManualMulti(inputData?: any) {
    try {
      return await this.axios.post<any>("/order/delivery/manual/multi", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e?.response?.data?.message);
    }
  }

  public async deliveryHandover(inputData?: any) {
    try {
      return await this.axios.put<any>("/order/delivery/handover", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e?.response?.data?.message);
    }
  }

  public async resendDataAmh(inputData?: any) {
    try {
      return await this.axios.put<any>("/order/delivery/handover/resend-data", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e?.response?.data?.message);
    }
  }

  async getAssignedOrder(params: any) {
    try {
      const queries = {
        ...(params?.service_bureau_code && {
          service_bureau_code: params.service_bureau_code,
        }),
        ...(params?.dealer_code && {
          dealer_code: params.dealer_code,
        }),
        ...(params?.order_code && {
          order_code: params.order_code,
        }),
        ...(params?.date_start && {
          date_start: params.date_start,
        }),
        ...(params?.date_end && {
          date_end: params.date_end,
        }),
        ...(params?.transfer_title_status &&
          params?.transfer_title_status !== "ALL" && {
            transfer_title_status: params.transfer_title_status,
          }),
        ...(params?.invoice_number && {
          invoice_number: params.invoice_number,
        }),
        ...(params?.vehicle_engine_number && {
          vehicle_engine_number: params.vehicle_engine_number,
        }),
        ...(params?.notice_uploaded !== undefined && {
          notice_uploaded: params.notice_uploaded,
        }),
        ...(params?.paid_notice_cost !== undefined && {
          paid_notice_cost: params.paid_notice_cost,
        }),
        ...(params?.paid_process_cost !== undefined && {
          paid_process_cost: params.paid_process_cost,
        }),
        ...(params?.flag_has_outstanding !== undefined && {
          flag_has_outstanding: params.flag_has_outstanding,
        }),
        ...(params?.stnk_uploaded !== undefined && {
          stnk_uploaded: params.stnk_uploaded,
        }),
        ...(params?.payment_approved !== undefined && {
          payment_approved: params.payment_approved,
        }),
      };

      return await this.axios.get("/order/assign-service-bureau", {
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.message);
    }
  }

  public async bbnApprovalPayment(inputData?: any) {
    try {
      return await this.axios.put<any>("/service-bureau/order/update/payment-approval", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e?.response?.data?.message);
    }
  }
}

export const orderService = new OrderService();
